import React from 'react';
import { Navigate, RouteProps } from 'react-router-dom';
import * as Pages from 'routes/pages';
import routesPaths from 'routes/routesPaths';

type RouteInterface = RouteProps & {
    path: string;
};

const routes: RouteInterface[] = [
    {
        path: routesPaths.PRE_REGISTER,
        element: <Pages.PreRegister />,
    },
    {
        path: routesPaths.GP_PORTAL,
        element: <Pages.GPPortal />,
    },
    {
        path: routesPaths.UploadDocuments,
        element: <Pages.UploadDocuments />,
    },
    {
        path: routesPaths.REGISTER,
        element: <Pages.Register />,
    },
    {
        path: routesPaths.AUTHENTICATION_LOGIN_CALLBACK,
        element: <Pages.AuthenticationLoginCallback />,
    },
    {
        path: routesPaths.AUTHENTICATION_LOGIN_ERROR_CALLBACK,
        element: <Pages.AuthenticationLoginErrors />,
    },
    {
        path: routesPaths.ACTIVATE_USER,
        element: <Pages.ActivateUser />,
    },
    {
        path: routesPaths.Invitation,
        element: <Pages.Invitation />,
    },
    {
        path: '/',
        element: <Navigate to={routesPaths.PRE_REGISTER} replace />,
    },
];

// ** 404 Page
routes.push({
    path: '*',
    element: <Navigate to={routesPaths.PRE_REGISTER} replace />,
});

export default routes;
